import React, { Fragment, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import { Container, Row, Alert } from 'reactstrap'
import { toast } from 'react-toastify'
import axios from 'axios'
import { Breadcrumbs } from '../../../../AbstractElements'
import API_BASE_URL from '../../../../Config/api'
import LeftformDesc from './LeftformDesc'
import Rightformdesc from './Rightformdesc'

const AddProduct = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const [imageFile, setImageFile] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handlesavechange = async (data) => {
        setSaving(true);
        setError('');
        try {
            const formData = new FormData();
            formData.append('title', data.productname || '');
            formData.append('sku', data.sku || '');
            formData.append('hsn_code', data.hsn_code || '');
            formData.append('category', data.category || '');
            formData.append('collection', data.collection || '');
            formData.append('colour', data.colour || '');
            formData.append('fabric', data.fabric || '');
            formData.append('size', data.size || '');
            formData.append('wholesale_price', data.wholesale_price ?? '');
            formData.append('wholesale_price_usd', data.wholesale_price_usd ?? '');
            formData.append('wholesale_price_gbp', data.wholesale_price_gbp ?? '');
            formData.append('retail_euro', data.retail_euro ?? '');
            if (imageFile) formData.append('image', imageFile);

            await axios.post(`${API_BASE_URL}/api/add-product`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            toast.success('Product added successfully');
            navigate(`${process.env.PUBLIC_URL}/product-list`);
        } catch (err) {
            console.error('Error adding product:', err);
            setError(err?.response?.data?.error || 'Failed to add product. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Fragment>
            <Breadcrumbs parent="Products" title="Add Product" mainTitle="Add Product" />
            <Container fluid={true} className='add-product'>
                {error && <Alert color="danger">{error}</Alert>}
                <Row>
                    <LeftformDesc handlesavechange={handlesavechange} register={register} handleSubmit={handleSubmit} errors={errors} />
                    <Rightformdesc handlesavechange={handlesavechange} register={register} handleSubmit={handleSubmit} errors={errors} setImageFile={setImageFile} saving={saving} />
                </Row>
            </Container>
        </Fragment>
    )
}

export default AddProduct
